(function () {
  'use strict';

  function decodeList(value) {
    for (let depth = 0; depth < 4; depth += 1) {
      if (Array.isArray(value)) {
        if (value.length === 1 && typeof value[0] === 'string' && /^\s*\[/.test(value[0])) {
          value = value[0];
          continue;
        }
        return value.every(item => typeof item === 'string') ? value : null;
      }
      if (typeof value !== 'string' || !value.trim()) return [];
      try {
        value = JSON.parse(value);
      } catch (_) {
        // Some legacy imports escaped the array delimiters as well as its values.
        const repaired = value.replace(/(^|[\[,]\s*)\\"/g, '$1"').replace(/\\"(?=\s*[,\]])/g, '"');
        if (repaired === value) return null;
        try { value = JSON.parse(repaired); } catch (_) { return null; }
      }
    }
    return Array.isArray(value) && value.every(item => typeof item === 'string') ? value : null;
  }

  document.querySelectorAll('[data-feature-titles]').forEach(grid => {
    const titles = decodeList(grid.dataset.featureTitles);
    const descriptions = decodeList(grid.dataset.featureDescriptions);
    if (!titles || !descriptions) return;
    const cards = document.createDocumentFragment();
    titles.forEach((title, index) => {
      if (!title.trim()) return;
      const card = document.createElement('div');
      card.className = 'cl-feature-card';
      const heading = document.createElement('h3');
      heading.textContent = title;
      card.appendChild(heading);
      if (descriptions[index] && descriptions[index].trim()) {
        const description = document.createElement('p');
        description.textContent = descriptions[index];
        card.appendChild(description);
      }
      cards.appendChild(card);
    });
    grid.replaceChildren(cards);
  });
}());
